<div [ngClass]="signUpFlow ? 'fixed-header-btn' : ''">
  @if (userProfile$ | async; as user) {
    <div
      display="dynamic"
      placement="bottom-end"
      ngbDropdown
      class="profile-dropdown">
      <button
        class="btn btn-sm"
        [ngClass]="signUpFlow ? 'btn-light' : 'btn-dark'"
        id="profileDropdown"
        ngbDropdownToggle>
        <app-avatar
          [firstName]="user.first_name"
          [lastName]="user.last_name"></app-avatar>
        <div class="mx-2 d-none d-md-inline-block">{{ user.first_name }} {{ user.last_name }}</div>
      </button>
      <div
        ngbDropdownMenu
        aria-labelledby="profileDropdown">
        <div class="profile-photo">
          <app-avatar
            [firstName]="user.first_name"
            [lastName]="user.last_name"
            [size]="'xl'"></app-avatar>
          <div class="h4 text-dark mt-3">{{ user.first_name }} {{ user.last_name }}</div>
          <div class="text-muted">{{ user.email }}</div>
        </div>
        <div class="nav nav-pills flex-column">
          @if (!signUpFlow) {
            <div class="nav-item">
              <a
                [disabled]="!hasNavigationAccess"
                ngbDropdownItem
                class="nav-link"
                routerLink="settings">
                <div>
                  <i class="iconoir-settings icon-block"></i>
                  Settings
                </div>
                <i class="iconoir-nav-arrow-right"></i>
              </a>
            </div>
          }
          <div class="nav-item">
            <a
              ngbDropdownItem
              href="{{ liveUrl }}about-us"
              rel="noopener"
              target="_blank"
              class="nav-link">
              <div>
                <i class="iconoir-city icon-block"></i>
                About us
              </div>
              <i class="iconoir-nav-arrow-right"></i>
            </a>
          </div>
          <div class="nav-item">
            <a
              class="nav-link"
              ngbDropdownItem
              routerLink="/terms-and-conditions"
              target="_blank">
              <div>
                <i class="iconoir-info-circle icon-block"></i>
                Terms and conditions
              </div>
              <i class="iconoir-nav-arrow-right"></i>
            </a>
          </div>
          <div class="nav-item">
            <button
              ngbDropdownItem
              (click)="onLogOut()"
              (keydown)="onLogOut()">
              <div>
                <i class="iconoir-log-out icon-block"></i>
                Log out
              </div>
              <i class="iconoir-nav-arrow-right"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  }
</div>
